import { validateEmail } from './helpers';

class Validations {
  errorMsg = '';
  validations: Function[] = [];

  pushValidation(validation) {
    this.validations.push(validation);
  }

  required(errorMsg = '') {
    this.pushValidation((value) => (!value?.toString().trim() ? errorMsg : ''));
    return this;
  }

  email(errorMsg = '') {
    this.pushValidation((value) => (!validateEmail(value) ? errorMsg : ''));
    return this;
  }

  exist(errorMsg = '') {
    this.pushValidation((value) => (!value ? errorMsg : ''));
    return this;
  }

  minLength(errorMsg = '', length = 3) {
    this.pushValidation((value) => (value?.trim().length <= length ? errorMsg : ''));
    return this;
  }

  maxLength(errorMsg = '', length = 200) {
    this.pushValidation((value) => (value?.trim().length > length ? errorMsg : ''));
    return this;
  }

  greaterThan(errorMsg = '', min) {
    this.pushValidation((value) => (value <= min ? errorMsg : ''));
    return this;
  }

  run(value) {
    this.errorMsg = this.validations.reduce((acc, validation) => {
      if (!acc) {
        return validation(value);
      } else return acc;
    }, '');
    return this;
  }
}

export const createValidation = () => new Validations();

export const createSchema = (schema) => ({
  cast: (fields) => {
    const errors = Object.entries(fields).reduce((accErrors, [key, value]) => {
      const validations = schema[key];

      if (!validations) {
        return accErrors;
      }

      const validated = validations?.run(value);

      if (validated?.errorMsg) {
        return { ...accErrors, [key]: validated.errorMsg };
      } else {
        return accErrors;
      }
    }, {});

    return errors;
  },
});
